import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import Loginheader from '../Loginheader';
import Menu from '../Menu';

import * as Common from '../Common';

function LogReport() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [repFromDate, setRepFromDate] = useState(new Date());
    const [repToDate, setRepToDate] = useState(new Date());
    const [repMode, setRepMode] = useState("D");

    const [repOutput, setRepOutput] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPLOGEXTRACT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function genReport() {
        var object1 = {
            right: 'REPLOGEXTRACT',
            mode: repMode,
            frmdt: Common.dateYMD(repFromDate),
            todt: Common.dateYMD(repToDate)
        }
        console.log(object1);
        if (repMode === "D") {
            Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(object1)]);
        } else if (repMode === "V") {
            Common.callApi(Common.apiReport, [sid, JSON.stringify(object1)], function (result) {
                setRepOutput(result);
            });
        }
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Log Report</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className='divHide'>
                        <Form.Group>
                            <Form.Label>Mode </Form.Label>
                            <Form.Select
                                value={repMode}
                                onChange={(e) => setRepMode(e.target.value)} >
                                <option value="D">Download</option>
                                <option value="V">View</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={repFromDate}
                                onChange={(date) => setRepFromDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={repToDate}
                                onChange={(date) => setRepToDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>

                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button variant="outline-primary" size="sm" onClick={() => genReport()}>Generate</Button>&nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {parse(repOutput)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default LogReport;